/* Bluvana Silk — policy pages.
   Shopify's policy template is fixed markup we cannot edit, so the contents
   list is built here from the h2s already in the body. Nothing else on the
   page depends on it: with JS off the policy still reads top to bottom. */
(function () {
  var MIN_HEADINGS = 3;
  var DESKTOP = '(min-width: 1000px)';

  function slug(text, taken) {
    var base = String(text)
      .toLowerCase()
      .replace(/[‘’“”]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'section';
    var id = base;
    var n = 2;
    while (taken[id]) id = base + '-' + n++;
    taken[id] = true;
    return id;
  }

  /* Headings in Terms carry their own numbering ("4. Orders, changes, and
     cancellations"). The rail is narrow, so the number is dropped from the
     link text and shown in its own column instead. */
  function split(text) {
    var m = /^\s*(\d+)\s*[.)]\s+(.*)$/.exec(text);
    return m ? { num: m[1], label: m[2] } : { num: '', label: text.trim() };
  }

  function chevron() {
    return (
      '<svg class="silk-policy-toc__chevron" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
      '<path d="M3.5 6L8 10.5 12.5 6" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>'
    );
  }

  function markMeta(body) {
    var first = body.querySelector('.rte > p:first-child, p:first-child');
    if (first && /^\s*last updated\b/i.test(first.textContent || '')) {
      first.classList.add('policy-meta');
    }
  }

  function buildToc(headings) {
    var taken = {};
    var items = '';

    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      var text = (h.textContent || '').trim();
      if (!text) continue;
      if (!h.id) h.id = slug(text, taken);

      var parts = split(text);
      items +=
        '<li><a href="#' + h.id + '">' +
        (parts.num ? '<span aria-hidden="true">' + parts.num + '.</span> ' : '') +
        parts.label.replace(/[&<>]/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c];
        }) +
        '</a></li>';
    }

    if (!items) return null;

    var toc = document.createElement('details');
    toc.className = 'silk-policy-toc';
    toc.innerHTML =
      '<summary class="silk-policy-toc__summary">Contents' + chevron() + '</summary>' +
      '<ol class="silk-policy-toc__list">' + items + '</ol>';
    return toc;
  }

  /* Open on the rail, collapsed on narrow screens where it sits above the
     text and would otherwise push the policy off the first screen. */
  function followViewport(toc) {
    var mq = window.matchMedia(DESKTOP);
    var sync = function () {
      toc.open = mq.matches;
    };
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  }

  /* Desktop scrolls inside .page-wrapper, phones scroll the document; the
     positions come from getBoundingClientRect so both behave the same. */
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 2 && /auto|scroll/.test(window.getComputedStyle(pw).overflowY)) return pw;
    return document.scrollingElement || document.documentElement;
  }

  function trackActive(toc, headings) {
    var links = toc.querySelectorAll('a');
    var ticking = false;

    function update() {
      ticking = false;
      var el = scroller();
      var line = window.innerHeight * 0.35;
      var currentId = headings[0].id;

      /* at the top the first section is the one being read, whatever sits on the line */
      if (el.scrollTop >= 48) {
        for (var i = 0; i < headings.length; i++) {
          if (headings[i].getBoundingClientRect().top <= line) currentId = headings[i].id;
        }
      }
      /* at the very bottom the last section wins even if it is short */
      if (el.scrollHeight > el.clientHeight + 2 && el.scrollTop + el.clientHeight >= el.scrollHeight - 2) {
        currentId = headings[headings.length - 1].id;
      }

      for (var l = 0; l < links.length; l++) {
        if (links[l].getAttribute('href') === '#' + currentId) links[l].setAttribute('aria-current', 'true');
        else links[l].removeAttribute('aria-current');
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    /* capture phase: scroll events do not bubble, this hears the window and .page-wrapper alike */
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    /* the ids are minted here, so a #fragment jump can land after we first ran */
    window.addEventListener('load', onScroll);
    window.setTimeout(onScroll, 400);
    update();
  }

  function init() {
    var body = document.querySelector('.silk-policy-template .shopify-policy__body');
    var title = document.querySelector('.silk-policy-template .shopify-policy__title');
    if (!body || !title) return;

    markMeta(body);

    var headings = body.querySelectorAll('h2');
    if (headings.length < MIN_HEADINGS) return;

    var toc = buildToc(headings);
    if (!toc) return;

    toc.setAttribute('aria-label', 'Contents');
    title.appendChild(toc);
    followViewport(toc);
    trackActive(toc, headings);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
